import { render, staticRenderFns } from "./Ceu2.vue?vue&type=template&id=db51c1f4&scoped=true"
import script from "./Ceu2.vue?vue&type=script&lang=js"
export * from "./Ceu2.vue?vue&type=script&lang=js"
import style0 from "./Ceu2.vue?vue&type=style&index=0&id=db51c1f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db51c1f4",
  null
  
)

export default component.exports